import React, { useState, useEffect } from "react"
import styled from "@emotion/styled"
import { injectIntl } from "gatsby-plugin-intl"
import ReactPlayer from "react-player"

const SommierStyleSectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  color: #1b2a56;
  width: 100%;
`

const RowWrapper = styled.div`
  display: flex;
  background: ${({ background }) => (background ? background : "#fff")};
  width: 100%;
`

const Row = styled.div`
  width: 100%;
  display: flex;

  @media (max-width: 600px) {
    flex-direction: column;
  }
`

const ColumnBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0px 20px;

  :last-of-type {
    @media (max-width: 600px) {
      margin-top: 30px;
    }
  }

  @media (max-width: 600px) {
    margin: 0px;
    display: ${({ page }) => (page === "sommier-electric" ? "none" : "flex")};
  }
`

const DimensionBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #000;

  :first-of-type {
    border-top: 1px solid #000;
  }
`

const ImageWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin: 20px 20px;

  @media (max-width: 600px) {
    margin: 10px 0px;
  }
`

const LeftSection = styled.div`
  width: 100%;
  display: flex;

  @media (max-width: 600px) {
    width: calc(100% + 40px);
    margin-left: -20px;
  }
`

const IframeBox = styled.div`
  position: relative;
  padding-top: 62%;
  width: 100%;
  overflow: hidden;

  iframe,
  video {
    width: 100%;
    height: 100%;
    margin: 0;
    border: 0px;
    position: absolute;
    z-index: 1;
    right: 0;
    bottom: 0;
    left: 0;
    top: 0;
    object-fit: fill;
    object-position: 50% 50%;
  }

  > div {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0px;
  }
`

const SommierStyleSectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 1200px;
  width: 100%;
  margin: 0px auto;
  padding: 20px 20px;
`

const DimensionContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 1200px;
  width: 100%;
  margin: 0px auto;
  padding: 40px 20px;

  @media (max-width: 600px) {
    padding: 0px 20px 30px;
  }
`

const SectionTitle = styled.h2`
  font-size: 36px;
  font-weight: bold;
  font-family: "BebasNeueBold";
  line-height: 1;
  margin: 0px 0px 10px 0px;
  text-align: center;

  @media (max-width: 600px) {
    text-align: left;
  }
`

const Image = styled.img`
  max-width: 100%;
  margin: 0px 0px 15px;
  object-fit: contain;

  @media (max-width: 600px) {
    max-width: 100%;
  }
`

const TitleWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0px 10px 10px;
`

const Title = styled.h3`
  font-family: "Museo";
  color: #1b2a56;
  font-size: 20px;
  font-weight: 900;
  line-height: 1.2;
  margin: 0px;

  @media (max-width: 600px) {
    font-size: 16px;
  }
`

const Text = styled.p`
  font-family: "Gotham Book";
  color: #1b2a56;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.2;
  margin: 0px;
`

const ImageBox = styled.div`
  display: ${({ visible }) => (visible ? "flex" : "none")};
  width: 100%;
  padding: 15px;
  flex-basis: 100%;
  align-items: center;
`

const ImageBoxClose = styled.div`
  min-width: 25px;
  width: 25px;
  height: 25px;
  border: 1.5px solid #1b2a56;
  border-radius: 50%;
  text-align: center;
  cursor: pointer;
  font-size: 20px;
  line-height: 1;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
`

const BannerImage = styled.img`
  width: 100%;
  height: 100%;
  margin: 0px;
  top: 0px;
  object-fit: cover;
`

const SommierStyleSection = ({ intl, data, size, id, page }) => {
  const [visibleAuthorBox, setvisibleAuthorBox] = useState(0)
  const openAuthorBox = i => {
    setvisibleAuthorBox(i)
  }
  useEffect(() => {
    setvisibleAuthorBox(size)
  }, [size])
  return (
    data && (
      <SommierStyleSectionWrapper
        id={id}
        className={id ? "lyneup-page-section" : ""}
      >
        <RowWrapper>
          <SommierStyleSectionContainer>
            {data.section_title && (
              <SectionTitle
                dangerouslySetInnerHTML={{
                  __html: data.section_title,
                }}
              />
            )}
            <Row>
              {data.list &&
                data.list.map((item, index) => {
                  return (
                    item &&
                    item.text && (
                      <ImageWrapper key={index.toString()}>
                        <Image
                          className="lazyload"
                          data-src={item.image}
                          alt={item.alt ? item.alt : ""}
                        />
                        <Text
                          dangerouslySetInnerHTML={{
                            __html: item.text,
                          }}
                        />
                      </ImageWrapper>
                    )
                  )
                })}
            </Row>
          </SommierStyleSectionContainer>
        </RowWrapper>
        <RowWrapper background="#ECF7FB">
          <DimensionContainer>
            <Row>
              {data.image && (
                <ColumnBox page={page}>
                  <LeftSection>
                    {page === "sommier-electric" ? (
                      <BannerImage
                        className="lazyload"
                        data-src={data.image}
                        alt={data.alt ? data.alt : ""}
                      />
                    ) : (
                      <IframeBox>
                        <ReactPlayer
                          url={
                            page === "sommier-original"
                              ? "https://www.percko.com/videos/percko.com/eur-fr/sommier-zone-original/page_sommier_original_-_video_1.mp4"
                              : page === "sommier-bois-massif"
                              ? "https://www.percko.com/videos/percko.com/eur-fr/sommier-zone-bois-massif/page_sommier_bois_massif_-_video_1.mp4"
                              : "https://www.percko.com/videos/percko.com/eur-fr/sommier-zone-coffre/video-sommier-coffre.mp4"
                          }
                          // light={data.image}
                          playing={true}
                          controls={false}
                          muted={true}
                          loop={true}
                          width="100%"
                          height="100%"
                          playsinline={true}
                          playsInline
                        />
                      </IframeBox>
                    )}
                  </LeftSection>
                </ColumnBox>
              )}

              {data.style_list && (
                <ColumnBox>
                  {data.style_list.map((style_item, style_index) => {
                    return (
                      style_item &&
                      style_item.image &&
                      style_item.text && (
                        <DimensionBox key={style_index.toString()}>
                          <TitleWrapper>
                            <Title
                              dangerouslySetInnerHTML={{
                                __html: style_item.text,
                              }}
                            />
                            {style_item.image && (
                              <ImageBoxClose
                                onClick={() => openAuthorBox(style_item.size)}
                              >
                                {visibleAuthorBox === style_item.size
                                  ? "-"
                                  : "+"}
                              </ImageBoxClose>
                            )}
                          </TitleWrapper>
                          {style_item.image && (
                            <ImageBox
                              visible={visibleAuthorBox === style_item.size}
                            >
                              <Image
                                className="lazyload"
                                data-src={style_item.image}
                                alt={style_item.alt ? style_item.alt : ""}
                              />
                            </ImageBox>
                          )}
                        </DimensionBox>
                      )
                    )
                  })}
                </ColumnBox>
              )}
            </Row>
          </DimensionContainer>
        </RowWrapper>
      </SommierStyleSectionWrapper>
    )
  )
}

export default injectIntl(SommierStyleSection)
